import { Row, ThemeText, View, Column } from '@/components/Theme';
import { elements } from '@/constants/Styles';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { ResponseIcon } from './ResponseIcon';

export const SuccessView = memo((props) => {
    const { 
        title = null, 
        text, 
        icon = 'check',
        contentContainerStyle = null, 
        size = '2xl', 
        innerPadding = 12,
        children = null
    } = props;

    return (
        
        <Column gap={15} alignItems={'center'} style={contentContainerStyle}>    
            
            <ResponseIcon 
                icon={icon}
                innerPadding={innerPadding}
                colorScheme={'green'}
                iconSize={size}
            />
            
            {title != null &&
                <ThemeText light={'green.500'} dark={'green.200'} variant={'h1'} id={title} />
            }
            
            {text != null &&
                <ThemeText variant={'p'} id={text} />
            }
            
            {children?.length > 0 && 
                <>
                    <View h={5} />
                    
                    <Row gap={12} style={[elements.center, {marginTop: 20, flexWrap: 'wrap'}]}>
                        {children}
                    </Row>
                </>
            }
        
        </Column>
    );
}, isEqual);

const styles = StyleSheet.create({
    container: {
        ...elements.center,
        flexDirection: 'column',
        zIndex: 1000,
        gap: 15
    },
});